export default __webpack_public_path__ + "static/media/69.a184babe.jpg";